import { render, staticRenderFns } from "./b4.vue?vue&type=template&id=3439ca0b&"
import script from "./b4.vue?vue&type=script&lang=js&"
export * from "./b4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports